import styled from 'styled-components';

export const Clear = styled.div`
    clear: both;
`;

